/**
 * Dual Section Modal functionality
 * Handles opening/closing modals triggered by popup links in dual section blocks
 */

(function () {
  'use strict';

  class DualSectionModal {
    constructor() {
      this.modals = [];
      this.activeModal = null;
      this.init();
    }

    init() {
      // Find all modal triggers on the page
      const triggers = document.querySelectorAll('.dual-section-modal-trigger');

      if (triggers.length === 0) {
        return; // No modals on this page, exit early
      }

      // Bind events for each trigger
      triggers.forEach((trigger) => {
        const modalId = trigger.getAttribute('data-modal-id');
        const modal = document.getElementById(modalId);

        if (modal) {
          this.modals.push({ trigger, modal, modalId });
          this.bindTriggerEvents(trigger, modal);
          this.bindCloseEvents(modal);
        }
      });

      // Bind escape key to close modal
      this.bindEscapeKey();

      // Bind click outside modal to close
      this.bindOutsideClick();
    }

    bindTriggerEvents(trigger, modal) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.openModal(modal);
      });
    }

    bindCloseEvents(modal) {
      const closeBtn = modal.querySelector('.modal-close');

      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeModal(modal);
        });
      }
    }

    bindEscapeKey() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.activeModal) {
          this.closeModal(this.activeModal);
        }
      });
    }

    bindOutsideClick() {
      document.addEventListener('click', (e) => {
        if (this.activeModal && e.target.classList.contains('dual-section-modal')) {
          this.closeModal(this.activeModal);
        }
      });
    }

    openModal(modal) {
      if (!modal) return;

      // Close any other open modal first
      if (this.activeModal) {
        this.closeModal(this.activeModal);
      }

      modal.classList.add('is-active');
      this.activeModal = modal;

      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';

      // Set focus to modal for accessibility
      modal.focus();
    }

    closeModal(modal) {
      if (!modal) return;

      modal.classList.remove('is-active');
      this.activeModal = null;

      // Restore body scroll
      document.body.style.overflow = '';
    }
  }

  // Initialize on document ready (vanilla JS)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new DualSectionModal());
  } else {
    new DualSectionModal();
  }

})();
